import React from "react";
import { BaseLegend } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function Legend(_ref) {
  var content = _ref.content,
    id = _ref.id;
  return /*#__PURE__*/_jsx(BaseLegend, {
    id: id,
    children: content
  });
}
export default Legend;